import { PipelineNode } from 'pipelines/types/pipeline_node';
import { validatePipelineNode } from './validate_pipeline_node';

export function removeInvalidPipelineNodes(definition: PipelineNode[]) {
  return definition.filter((node) => validatePipelineNode(node) === true);
}
